import { FormKitTypeDefinition } from '@formkit/core';
import {
  outer,
  boxInner,
  help,
  boxHelp,
  messages,
  message,
  prefix,
  suffix,
  fieldset,
  decorator,
  box,
  icon,
  legend,
  boxOption,
  boxOptions,
  boxWrapper,
  boxLabel,
  options,
  radios,
  $if,
  $extend,
  defaultIcon,
} from '@formkit/inputs';

function customInputClassOverrides(node: any) {
  node.props.optionsClass = '$reset formkit-options flex flex-col gap-3 pt-1';
  node.props.decoratorClass = `$reset 
      block relative h-6 w-6 md:h-5 md:w-5 mr-3 mt-[2px] rounded-full border-2 border-racq-light-blue-grey text-transparent bg-white
      peer-checked:border-racq-blue-active peer-checked:text-racq-blue-active
      peer-focus-visible:outline-2 peer-focus-visible:outline-dashed peer-focus-visible:outline-racq-navy peer-focus-visible:outline-offset-2`;
  node.props.decoratorIconClass = `$reset 
      flex w-full h-full max-w-[12px] md:max-w-[10px] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 racq-radio-decorator-icon`;
  node.props.labelClass = `$reset 
      text-base text-racq-dark-grey`;
  node.props.optionHelpClass = `$reset 
      text-xs text-racq-dark-grey ml-[36px]`;
}

/**
 * This component generated via exporting the default radio https://formkit.com/guides/export-and-restructure-inputs#export-via-cli
 * and then adding the classes above in `customInputClassOverrides`
 */
export const nativeRadio: FormKitTypeDefinition = {
  /**
   * The actual schema of the input, or a function that returns the schema.
   */
  schema: outer(
    $if(
      '$options == undefined',
      /**
       * Single radio structure.
       */
      boxWrapper(
        boxInner(prefix(), box(), decorator(icon('decorator')), suffix()),
        $extend(boxLabel('$label'), {
          if: '$label',
        })
      ),
      /**
       * Multi radio structure.
       */
      fieldset(
        legend('$label'),
        help('$help'),
        boxOptions(
          boxOption(
            boxWrapper(
              boxInner(
                prefix(),
                $extend(box(), {
                  bind: '$option.attrs',
                  attrs: {
                    id: '$option.attrs.id',
                    value: '$option.value',
                    checked: '$fns.isChecked($option.value)',
                    'aria-label': '$option.label',
                  },
                }),
                decorator(icon('decorator')),
                suffix()
              ),
              $if(
                '$option.srOnly',
                $extend(boxLabel('$option.label'), {
                  if: '$option.label',
                  attrs: {
                    class: 'sr-only',
                  },
                }),
                $extend(boxLabel('$option.label'), {
                  if: '$option.label',
                })
              )
            ),
            boxHelp('$option.help')
          )
        )
      )
    ),
    // Help text only goes under the input when it is a single.
    $if('$options == undefined && $help', help('$help')),
    messages(message('$message.value'))
  ),
  /**
   * The type of node, can be a list, group, or input.
   */
  type: 'input',
  /**
   * The family of inputs this one belongs too. For example "text" and "email"
   * are both part of the "text" family. This is primary used for styling.
   */
  family: 'box',
  /**
   * An array of extra props to accept for this input.
   */
  props: ['options', 'onValue', 'offValue', 'optionsLoader'],
  /**
   * Forces node.props.type to be this explicit value.
   */
  forceTypeProp: 'radio',
  /**
   * Additional features that should be added to your input
   */
  features: [options, radios, defaultIcon('decorator', 'radioDecorator'), customInputClassOverrides],
  /**
   * The key used to memoize the schema.
   */
  schemaMemoKey: 'cj1gc7cw3na',
};
